import styled from 'styled-components';
import ThemeHelper from '../../themes/theme-helper';

import { arrowHeight } from './index';

const getArrowTransformRotateDegree = props => {
  const { leftAlign, isOutOfWindowX } = props;

  if (leftAlign) return 'rotate(-90deg)';
  if (isOutOfWindowX) return 'rotate(-180deg)';

  return 'none';
};

const ModalWrapper = styled.div((props) => {
  const { colours } = ThemeHelper.getTheme(props);
  const { bgColor, borderRadius = 8 } = props;

  return `
        display: flex;
        align-items: center;
        background: ${bgColor};
        position: fixed;
        left: ${props.positionX}px
        border-radius: ${borderRadius}px;
        z-index: 99;
        box-shadow: 4px 2px 6px;
        overflow: ${props.overflow}
        overflow-wrap: ${props.overflowWrap}
        width:${props.modalWidth}px
        min-height: 50px;
        cursor: default;
        border: 1px solid ${bgColor}
        ${props.modalBottom ? `bottom: ${props.modalBottom}px;` : `top: ${props.positionY}px`}

        ::after {
                width: 0; 
                height: 0; 
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;        
                border-bottom: ${arrowHeight}px solid ${bgColor};
                position: fixed;
                top: ${props.positionArrowY}px;
                left: ${props.positionArrow}px;
                content: ' ';
                transform: ${getArrowTransformRotateDegree(props)};
        }
        * {
                color: ${colours.grey[900]}
                background: ${bgColor}
                &:hover {
                        color: ${colours.grey[900]}
                }
        }

        `;
});

const Content = styled.div`
  flex-direction: column;
  width: 100%;
`;

const ContentTheme = styled.div`
  flex-direction: column;
  width: 100%;
  padding: 10px;
  color: white;
`;

export { ModalWrapper, Content, ContentTheme };
